import { observable, action, computed, flow, toJS } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './CommentServ';
import { Toast } from 'antd-mobile';

class CommentMod {
  @observable showInfo = {};

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
  submit = flow(function* (params) {
    console.log('paramsparamsparams', params);

    try {
      const { data, resultCode } = yield Serv.submit(params);
      Toast.success('评价成功', 1, () => {
        return resultCode;
      });
      return resultCode;
    } catch (err) {}
  });

  /**
   * 提交订单
   */
  commitCommet = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.commitCommet(params);
      if (resultCode * 1 !== 0) {
        Toast.fail(resultMsg, 1);
      }
      return resultCode * 1;
    } catch (error) {
      return -1;
    }
  });

  // 获取评论信息
  getComment = flow(function* (tradeNo, type) {
    try {
      const { resultCode, data } = yield Serv.getComment(tradeNo, type);
      if (resultCode * 1 === 0) {
        return data;
      }
    } catch (error) {
      return -1;
    }
  });
}

const commentMod = new CommentMod();
export default commentMod;



// WEBPACK FOOTER //
// ./src/widget/Comment/CommentMod.js